import FamilleI18n from './Famille.i18n.js';
import {
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex'
export default {

  components: {},
  computed: {
    ...mapGetters(['families', 'dataLoading', 'products', 'cart']),
    /**
     *  Computed to get he category name.
     */
    getFamilyName() {
      let family
      if (this.families.length > 0) {
        this.families.forEach(aFam => {
          if (aFam.id === this.$route.params.famId) {
            family = aFam
          }
        })
        return family.name
      } else {
        return ""
      }
    },
  },
  props: {},

  data() {
    return {};
  },

  watch: {},

  methods: {
    ...mapMutations(['addToCart']),
    ...mapActions(['getFamilies', 'getProductsByFamily']),
    /**
     * Load products
     */
    loadProducts() {
      this.getProductsByFamily(this.$route.params.famId).then(res => {}).catch(err => {
        console.log(err)
      })
    },
    /**
     * Go to product page.
     * @param {*} pProd 
     */
    goToProduct(pProd) {
      // Not implemented yet.
    },

    /**
     * Function to know if the product is already in the cart.
     * @param {*} pProd 
     */
    isInCart(pProd) {
      let isInCart = false
      this.cart.forEach(aProduct => {
        if (aProduct.id === pProd.id) {
          isInCart = true
        }
      })
      return isInCart
    },

    /**
     * Add to cart.
     */
    addProductToCart(pProduct) {
      pProduct.quantity = 1
      pProduct.totalProductPrice = pProduct.price
      this.addToCart(pProduct)
    }
  },

  mounted() {
    if (this.families.length === 0) {
      this.getFamilies().then(res => {}).catch(err => {
        console.log(err)
      })
    }
    this.loadProducts()
  },

  i18n: FamilleI18n,

};



// WEBPACK FOOTER //
// ./src/views/Magasin/Famille/Famille.js